<template>
  <sc-drop
    accept="node"
    @drop="emit('move', [JSON.parse($event.data), node, 'inside'])"
    v-slot="{ hover }"
  >
    <div class="line" :class="{ hover }">
      <span class="arrow" @click="node.setOpen(!node.opened)">
        <sc-icon
          v-show="node.children.length > 0"
          :type="node.opened ? 'CaretDownOutlined' : 'CaretRightOutlined'"
        />
      </span>
      <div class="content">
        <sc-icon type="FolderTwoTone" />
        <div class="td">{{ node.data.name }}</div>
        <a-tag color="blue"  v-if="node.data.group">
          {{ node.data.group?.name }}
        </a-tag>
        <template v-if="node.data.tags">
          <a-tag color="green" v-for="(item, k) in node.data.tags.list" :key="k">
            {{ item.name }}
          </a-tag>
        </template>
        <div class="td" v-if="node.data.remark">
          {{ node.data.remark }}
        </div>
      </div>
    </div>
  </sc-drop>
</template>

<script lang="ts" setup>
import { DataNode } from '@/components/common/tree/TreeUtil';
import ScDrop from '@/components/common/drag/ScDrop';

const props = defineProps<{
  node: DataNode<any>;
}>();
const emit = defineEmits<{
  (event: 'move', ...args: Array<any>): void;
}>();
</script>

<style lang="scss" scoped>
.line {
  display: flex;
  flex-direction: row;
  align-items: center;

  .arrow {
    flex-shrink: 0;
    width: 22px;
    height: 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    color: #363636;
    padding-right: 6px;
  }

  .checkbox {
    margin-right: 6px;
  }

  .title {
    flex-grow: 1;
    padding-left: 6px;
  }

  &.hover {
    background: #d2e2da;
    //color: #fff;
  }
}

.content {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 32px;
  width: 100%;

  &.sub {
    border: 0.5px solid #f0f0f0;
  }

  .td {
    padding: 0 8px;
  }
}
</style>
